import ReactDOMServer from "react-dom/server";
// import DOMPurify from "dompurify";

function HtmlIframe({ parsedHtml }: { parsedHtml: string | React.ReactNode }) {
  const rawHtml =
    typeof parsedHtml === "string"
      ? parsedHtml
      : ReactDOMServer.renderToString(<>{parsedHtml}</>);

  // Sanitize only the body content
  // const safeBody = DOMPurify.sanitize(rawHtml, {
  //   ALLOWED_ATTR: ["style", "class"], // keep class + inline style
  //   FORBID_TAGS: ["script", "iframe", "object"], // strip dangerous stuff
  // });

  return (
    <iframe
      srcDoc={`<!DOCTYPE html>${rawHtml}`}
      style={{ width: "100%", height: "100vh", border: "none" }}
      title="html-iframe"
    />
  );
}

export default HtmlIframe;
